import { PROMOTION_TYPE } from '@/constants/promotion'

export default {
  computed: {
    participatedTC() {
      const eligibleCampaigns = this.$store.state.promotion.eligibleCampaigns || []

      return eligibleCampaigns.filter(
        item => item.campaignType === PROMOTION_TYPE.TRADING_CONTEST && item.participantAccount?.length
      )
    },
    participatedTCAccount() {
      return this.participatedTC
        .flatMap(campaign => campaign.participantAccount || [])
        .map(participant => participant.mt4Account)
    },
  },
}
